import { useGeoCitiesMasterdataQuery } from "@/features/masterdata/queries/geo-cities-masterdata-query";

export function useGeoCitiesMasterdata() {
  const geoCitiesQuery = useGeoCitiesMasterdataQuery();

  const geoCities = computed(() => geoCitiesQuery.data.value || []);

  function getCityByCode(code: string) {
    const city = geoCities.value.find((option) => option.code === code);
    if (!city) {
      throw new Error(`Could not find any city with code ${code} in master data store.`);
    }
    return city;
  }

  function getCityNameByCode(code?: string) {
    try {
      if (code) {
        return getCityByCode(code)?.name;
      }
      return "";
    } catch (error) {
      console.error(error);
      return "";
    }
  }

  return {
    geoCities,
    getCityByCode,
    getCityNameByCode,
    isLoading: geoCitiesQuery.isLoading,
    error: geoCitiesQuery.error,
    refetch: geoCitiesQuery.refetch,
  };
}
